export default "__VITE_ASSET__CT4my7$M__"